import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  userLogged: false,
  userInformations: {},
  // Used to temporary store the user to resend confirmation code
  formUserInformations: {}, // Used to save user information beewtin 2 register page
  registeringUser: {
    validated: false,
    email: null
  },
  commands: {},
  idToken: null,
  keepOfflineMode: false
}

export default {
  state,
  getters,
  actions,
  mutations
}
